import React from 'react';
import { useCart } from './CartContext';
import { Link, useNavigate } from 'react-router-dom';
import { FaTrash, FaArrowRight, FaCalendarAlt, FaBuilding, FaUserFriends, FaMinus, FaPlus } from 'react-icons/fa';
import EnvImage from './General Safety/env2.jpeg';
import WarehouseImage from './Warehouse Safety/ware.jpg';
import ConstructionImage from './Construction Safety/const.jpg';
import FireImage from './Emegency Safety/fire.jpg';
import ElectricalImage from './Electrical/elect.jpg';
import PPEImage from './General Safety/ppe.jpg';
import LOTOImage from './General Safety/loto.jpg';
import AwarenessImage from './General Safety/worker3.jpg';
import ScaffoldingImage from './Construction Safety/scaf.jpg';
import EmergencyImage from './Emegency Safety/emerg.jpg';
import MHEImage from './Warehouse Safety/mhe.jpg';
import BehaviorImage from './General Safety/behave.jpg';
import ISOImage from './ISO Training/iso.jpg';
import RoadSafetyImage from './Road Safety/safe.jpg';
import ErgonomicsImage from './Health Safety/erg.png';
import FirstAidImage from './Health Safety/aid.jpg';
import HeatStressImage from './Health Safety/heat.jpg';
import MentalHealthImage from './Health Safety/well.jpg';
import ComplianceLinkImage from '../Compliance/compliance_hero.png';
import ConsultancyLinkImage from '../Consultancy/consultancy_hero.png';
import AuditLinkImage from '../Audit/audit_hero.png';
import './CartPage.css';

function CartPage() {
  const { cartItems, removeFromCart, updateQuantity } = useCart();
  const navigate = useNavigate();

  // Helper to get the correct image
  const getItemImage = (item) => {
    const name = item.name.toLowerCase();
    const id = (item.id || '').toLowerCase();

    // 1. High-Priority: Check Specific Categories via ID or strict keywords
    if (id.includes('comp-') || name.includes('compliance')) return ComplianceLinkImage;
    if (id.includes('cons-') || name.includes('consultancy')) return ConsultancyLinkImage;
    if (id.includes('audit-') || name.includes('audit')) return AuditLinkImage;

    // 2. Map keywords to imported images
    if (name.includes('environmental') || id.includes('env')) return EnvImage;
    if (name.includes('warehouse') || id.includes('wh-')) return WarehouseImage;
    if (name.includes('construction') || id.includes('const-')) return ConstructionImage;
    if (name.includes('fire') || id.includes('fire-')) return FireImage;
    if (name.includes('electrical') || id.includes('elec-')) return ElectricalImage;
    if (name.includes('ppe') || name.includes('equipment')) return PPEImage;
    if (name.includes('loto') || name.includes('lockout')) return LOTOImage;
    if (name.includes('awareness')) return AwarenessImage;
    if (name.includes('height') || name.includes('scaffold')) return ScaffoldingImage;
    if (name.includes('emergency')) return EmergencyImage;
    if (name.includes('material') || name.includes('mhe')) return MHEImage;
    if (name.includes('behavior') || name.includes('behavioral')) return BehaviorImage;
    if (name.includes('iso') || id.includes('iso-')) return ISOImage;
    if (name.includes('road') || id.includes('road-')) return RoadSafetyImage;
    if (name.includes('ergonomic')) return ErgonomicsImage;
    if (name.includes('aid')) return FirstAidImage;
    if (name.includes('heat') || name.includes('stress')) return HeatStressImage;
    if (name.includes('mental') || name.includes('wellbeing')) return MentalHealthImage;

    // Otherwise use stored image or fallback
    return item.imageUrl || item.image || 'https://via.placeholder.com/150';
  };

  const handleRemoveItem = (id) => {
    removeFromCart(id);
  };

  const handleQuantityChange = (id, amount) => {
    updateQuantity(id, amount);
  };

  // Price calculations removed for quotation system

  if (cartItems.length === 0) {
    return (
      <div className="cart-page-container">
        <div className="cart-wrapper">
          <div className="empty-cart-state">
            <h2>Your Cart is Empty</h2>
            <p>Looks like you haven't added any training courses yet.</p>
            <br />
            <Link to="/training" className="btn-continue-shopping">
              Browse Courses
            </Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="cart-page-container">
      <div className="cart-wrapper">
        <div className="cart-header">
          <h1 className="cart-title">Your Selection</h1>
          <p className="cart-subtitle">{cartItems.length} Course{cartItems.length !== 1 ? 's' : ''} in your cart</p>
        </div>

        <div className="cart-content-grid">

          {/* LEFT COLUMN: ITEMS LIST */}
          <div className="cart-items-list">
            {cartItems.map((item) => (
              <div key={item.id} className="cart-item-card">

                <div className="item-image-wrapper">
                  <img
                    src={getItemImage(item)}
                    alt={item.name}
                    className="item-image"
                    onError={(e) => { e.target.onerror = null; e.target.src = 'https://via.placeholder.com/150'; }}
                  />
                </div>

                <div className="item-info">

                  <div className="item-main-details">
                    <div className="item-header">
                      <h3 className="item-name">{item.name}</h3>
                    </div>

                    {item.bookingDetails && (
                      <div className="booking-details-pill">
                        <div className="detail-row">
                          <FaCalendarAlt size={12} color="#FF6B00" /> <span>{item.bookingDetails.date}</span>
                        </div>
                        <div className="detail-row">
                          <FaUserFriends size={12} color="#FF6B00" /> <span>{item.bookingDetails.delegates} Delegate(s)</span>
                        </div>
                        {item.bookingDetails.company && (
                          <div className="detail-row">
                            <FaBuilding size={12} color="#FF6B00" /> <span>{item.bookingDetails.company}</span>
                          </div>
                        )}
                      </div>
                    )}
                  </div>

                  <div className="item-controls">
                    <div className="quantity-wrapper">
                      <button className="qty-btn" onClick={() => handleQuantityChange(item.id, -1)} disabled={item.quantity <= 1}>
                        <FaMinus size={14} />
                      </button>
                      <span className="qty-display">{item.quantity}</span>
                      <button className="qty-btn" onClick={() => handleQuantityChange(item.id, 1)}>
                        <FaPlus size={14} />
                      </button>
                    </div>

                    <button className="remove-btn" onClick={() => handleRemoveItem(item.id)}>
                      <FaTrash size={14} /> Remove
                    </button>
                  </div>

                </div>
              </div>
            ))}
          </div>

          {/* RIGHT COLUMN: SUMMARY */}
          <div className="cart-summary-panel">
            <h2 className="summary-title">Quote Summary</h2>

            <p className="summary-text">
              Review your selected items and proceed to submit a quotation inquiry.
            </p>

            <button className="btn-checkout" onClick={() => navigate('/checkout', { state: { cartItems } })}>
              Request Quote <FaArrowRight />
            </button>
          </div>

        </div>
      </div>
    </div>
  );
}

export default CartPage;
